// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2-88r","assignButton":"CreateEditEquipmentSchedule_assignButton__ADXZ0"};